/* eslint-disable */
import gaAsync from "@/js/common/Domain/Service/gaAsync";

var hotelPageGAEvents = function() {
    if(typeof gaEventsCall != "undefined") {
        setTimeout(function() {
            if(typeof  gaEventsCall['stars'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Stars', gaEventsCall['stars'], {'nonInteraction': 1})});
            }
            if(typeof gaEventsCall['photosNumber'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Hotel_pic', document.location.pathname, gaEventsCall['photosNumber'], {'nonInteraction': 1})});
            }

            if(typeof  gaEventsCall['rating'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Parameters', 'Rating', gaEventsCall['rating'], {'nonInteraction': 1})});
            }
            if(typeof  gaEventsCall['distance_to_the_beach'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Parameters', 'Distance_to_the_beach', gaEventsCall['distance_to_the_beach'], {'nonInteraction': 1})});
            }
            if(typeof  gaEventsCall['distance_to_the_lift'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Parameters', 'Distance_to_the_lift', gaEventsCall['distance_to_the_lift'], {'nonInteraction': 1})});
            }
            if(typeof  gaEventsCall['nearBeach'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Parameters', 'Near_the_beach', gaEventsCall['nearBeach'], {'nonInteraction': 1})});
            }
            if(typeof  gaEventsCall['nearLift'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Parameters', 'Near_the_lift', gaEventsCall['nearBeach'], {'nonInteraction': 1})});
            }
            if(typeof  gaEventsCall['wifi'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Parameters', 'Wi-fi', gaEventsCall['wifi'], {'nonInteraction': 1})});
            }
            if(typeof gaEventsCall['withChildren'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Parameters', 'Amenities_for_child`s', gaEventsCall['withChildren'], {'nonInteraction': 1})});
            }
            if(typeof  gaEventsCall['conditioner'] != "undefined") {
                gaAsync(function(){ga('send', 'event', 'Hotel_Card', 'Parameters', 'Conditioner', gaEventsCall['conditioner'], {'nonInteraction': 1})});
            }
        }, 5000);
    }
};

let hotelPageGAEventsView = {
    init:hotelPageGAEvents
};


export default hotelPageGAEventsView;